const Card = ({title, description}) => {
    return (
        <>
            <div className={'w-full group'}>
                <div className={'border border-gray-500 rounded-md p-4 min-h-[150px] group-hover:transition-all group-hover:bg-[#0A0D36] group-hover:border-white group-hover:scale-105'}>
                    <p className={'text-lg font-googleBold text-start uppercase group-hover:text-white'}> {title}</p>
                    <p className={'mt-6 text-sm text-gray-500 text-start tracking-wider group-hover:text-white leading-5 line-clamp-3'}>{description}
                    </p>
                </div>
            </div>
        </>
    )
};

export default Card;